// import React, { useState } from 'react';
// import Papa from 'papaparse';
// import jsPDF from 'jspdf';
// import JSZip from 'jszip';
// import { saveAs } from 'file-saver';

// const InvoiceGenerator = () => {
//   const [invoices, setInvoices] = useState([]);

//   const handleFileUpload = (event) => {
//     const file = event.target.files[0];
//     Papa.parse(file, {
//       header: true,
//       complete: (results) => {
//         const parsedData = results.data;
//         setInvoices(parsedData);
//       }
//     });
//   };

//   const generateInvoice = (invoiceData) => {
//     const doc = new jsPDF();
//     const items = [];

//     // Assuming a dynamic handling of items like Item 1, Item 2, etc.
//     for (let i = 1; i <= 10; i++) {
//       const description = invoiceData[`Item ${i} Description`];
//       const qty = invoiceData[`Item ${i} Qty`];
//       const price = invoiceData[`Item ${i} Price`];
//       if (description && qty && price) {
//         items.push({ description, qty, price });
//       }
//     }

//     // Invoice Template
//     doc.text(`Order Number: ${invoiceData['Order Number']}`, 10, 10);
//     doc.text(`Payment Date: ${invoiceData['Payment Date']}`, 10, 20);
//     doc.text(`Customer Name: ${invoiceData['Customer Name']}`, 10, 30);
//     doc.text(`Customer Email: ${invoiceData['Customer Email']}`, 10, 40);

//     let yPosition = 50;
//     items.forEach(item => {
//       doc.text(`Item: ${item.description}, Quantity: ${item.qty}, Price: $${item.price}`, 10, yPosition);
//       yPosition += 10;
//     });

//     doc.text(`Total: $${invoiceData['Payment Amount']}`, 10, yPosition + 10);

//     return doc;
//   };

//   const downloadInvoices = () => {
//     const zip = new JSZip();
//     invoices.forEach((invoice, index) => {
//       const doc = generateInvoice(invoice);
//       const pdfBlob = doc.output('blob');
//       zip.file(`Invoice_${invoice['Order Number']}.pdf`, pdfBlob);
//     });

//     zip.generateAsync({ type: 'blob' }).then((content) => {
//       saveAs(content, 'invoices.zip');
//     });
//   };

//   return (
//     <div>
//       <input type="file" accept=".csv" onChange={handleFileUpload} />
//       {invoices.length > 0 && (
//         <button onClick={downloadInvoices}>Download All Invoices</button>
//       )}
//     </div>
//   );
// };

// export default InvoiceGenerator;


import React, { useState } from 'react';
import Papa from 'papaparse';
import jsPDF from 'jspdf';
import 'jspdf-autotable';  // Import autoTable plugin for jsPDF
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import '../styles/invoice/InvoiceGenerator.css';
import ATH_LOGO from '../assets/images/ATH_LOGO.png';

const InvoiceGenerator = () => {
  const [invoices, setInvoices] = useState([]);
  const [generatedInvoices, setGeneratedInvoices] = useState([]); // Stores individual PDFs
  const [isLoading, setIsLoading] = useState(false);
  const [progress, setProgress] = useState(0);

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    Papa.parse(file, {
      header: true,
      complete: (results) => {
        const parsedData = results.data;
        setInvoices(parsedData);
      }
    });
  };

  const generateInvoice = (invoiceData) => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    doc.setFontSize(12);

    // First div: Logo (left) and Order Number + Payment Date (right)
    doc.addImage(ATH_LOGO, 'PNG', 10, 10, 50, 20); // Logo on the left
    doc.setFont('helvetica', 'bold'); // Bold font for headings
    doc.text(`Order Number: ${invoiceData['Order Number']}`, pageWidth - 10, 20, { align: 'right' }); // Right align order number
    doc.text(`Payment Date: ${invoiceData['Payment Date']}`, pageWidth - 10, 30, { align: 'right' }); // Right align payment date

    // Second div: Company Name + Address (left) and Customer Details (right)
    doc.text('Arts To Hearts Project', 10, 50); // Company name on the left
    doc.text('Hema enclave, lawyers colony, India', 10, 60); // Company address on the left

    doc.text(`Customer: ${invoiceData['Customer Name']}`, pageWidth - 10, 50, { align: 'right' }); // Right align customer name
    doc.text(`Email: ${invoiceData['Customer Email']}`, pageWidth - 10, 60, { align: 'right' }); // Right align customer email

    // Separator line
    doc.setLineWidth(0.5);
    doc.line(10, 70, 200, 70);

    // GST Number (centered)
    doc.setFont('helvetica', 'normal');
    doc.text('GST Number: 09BNRPA7283C1ZT', 10, 80); // Company address on the left

    // Table Header: Item, Quantity, Price, Line Total (Using autoTable for a proper table with borders)
    let tableData = getTableData(invoiceData);
    let totalLineTotal = calculateTotal(invoiceData);

    // Append the Total to the table
    tableData.push(['Total', '', '', `$${totalLineTotal.toFixed(2)}`]);

    doc.autoTable({
      startY: 90, // Starting Y position for the table
      head: [['Item', 'Quantity', 'Price', 'Line Total']], // Table headers
      body: tableData, // Table data including the total
      theme: 'grid', // Add borders to the table
      headStyles: { fillColor: [0, 0, 0] }, // Light gray header background
      styles: { fontSize: 10, halign: 'right' }, // Center the text in table cells
      columnStyles: {
        0: { halign: 'right' }, // Left align the item description
        1: { halign: 'right' }, // Center align the quantity
        2: { halign: 'right' }, // Right align the price
        3: { halign: 'right' }, // Right align the line total
      }
    });

    let finalY = doc.autoTable.previous.finalY; // Get the Y position after the table

    // Payment Details Section
    doc.setFont('helvetica', 'bold'); // Bold headings
    doc.text('Payment Details', 10, finalY + 20);

    doc.setFont('helvetica', 'normal'); // Normal font for the details
    doc.text(`• Amount: ${invoiceData['Payment Amount']}`, 20, finalY + 30);
    doc.text(`• Payment Method: ${invoiceData['Payment Method']}`, 20, finalY + 40);
    doc.text(`• Payment Status: ${invoiceData['Payment Status']}`, 20, finalY + 50);

    // Final Thank You Message (Centered at the bottom)
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(14);
    doc.text('Thank You For Your Order!', pageWidth / 2, finalY + 80, { align: 'center' });

    return doc;
  };

  // Helper function to generate the table data
  const getTableData = (invoiceData) => {
    const tableData = [];
    for (let i = 1; i <= 10; i++) {
      const description = invoiceData[`Item ${i} Description`];
      const qty = invoiceData[`Item ${i} Qty`];
      const price = invoiceData[`Item ${i} Price`];
      const lineTotal = invoiceData[`Item ${i} Line Total`];

      if (description && qty && price && lineTotal) {
        tableData.push([description, qty, `$${price}`, `$${lineTotal}`]);
      }
    }
    return tableData;
  };

  // Helper function to calculate the total line total
  const calculateTotal = (invoiceData) => {
    let totalLineTotal = 0;
    for (let i = 1; i <= 10; i++) {
      const lineTotal = parseFloat(invoiceData[`Item ${i} Line Total`]);
      if (!isNaN(lineTotal)) {
        totalLineTotal += lineTotal;
      }
    }
    return totalLineTotal;
  };

  const createInvoices = () => {
    setIsLoading(true);
    const generated = [];
    invoices.forEach((invoice, index) => {
      const doc = generateInvoice(invoice);
      const pdfBlob = doc.output('blob');
      const fileName = `Invoice_${invoice['Order Number']}_${invoice['Customer Name']}.pdf`;
      generated.push({ name: fileName, blob: pdfBlob, details: invoice });

      // Progress calculation based on the number of invoices generated
      setProgress(((index + 1) / invoices.length) * 100);
    });
    setGeneratedInvoices(generated);
    setIsLoading(false);
  };

  const downloadInvoices = () => {
    const zip = new JSZip();
    setIsLoading(true); // Start loader when downloading
    setProgress(0); // Reset progress

    generatedInvoices.forEach((invoice, index) => {
      zip.file(invoice.name, invoice.blob);

      // Update progress as each file is added to the zip
      setProgress(((index + 1) / generatedInvoices.length) * 100);
    });

    zip.generateAsync({ type: 'blob' }).then((content) => {
      saveAs(content, 'invoices.zip');
      setIsLoading(false);
    });
  };

  return (
    <div className="invoice-generator">
      <input type="file" accept=".csv" onChange={handleFileUpload} />

      {/* Button to create invoices */}
      <button className="generate-btn" onClick={createInvoices}>
        {isLoading ? `Creating Invoices... ${progress.toFixed(0)}%` : 'Create Invoices'}
      </button>

      {/* Loader with progress while creating invoices */}
      {isLoading && <div className="loader">Generating invoices, progress: {progress.toFixed(0)}%</div>}

      {/* Display the list of generated invoices */}
      {generatedInvoices.length > 0 && (
        <div className="invoice-list">
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <h3>Generated Invoices</h3>
            {/* Download all invoices button */}
            <button className="download-all-btn" onClick={downloadInvoices}>
              {isLoading ? `Downloading All... ${progress.toFixed(0)}%` : 'Download All Invoices'}
            </button>
          </div>
          <table className="invoice-table">
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Order ID</th>
                <th>Customer Name</th>
                <th>Email</th>
                <th>Payment Date</th>
                <th>Download</th>
              </tr>
            </thead>
            <tbody>
              {generatedInvoices.map((invoice, index) => (
                <tr key={index}>
                  <td>{index}</td>
                  <td>{invoice.details['Order Number']}</td>
                  <td>{invoice.details['Customer Name']}</td>
                  <td>{invoice.details['Customer Email']}</td>
                  <td>{invoice.details['Payment Date']}</td>
                  <td>
                    <a
                      href={URL.createObjectURL(invoice.blob)}
                      download={invoice.name}
                      className="download-link"
                    >
                      Download
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default InvoiceGenerator;